/**
 * ルールタイプ ValueObject
 * - assignable: 割り当て可能
 * - prohibited: 割り当て禁止
 */
export type RuleType = 'assignable' | 'prohibited';

/**
 * ルールタイプ表示ラベル
 */
export const RULE_TYPE_LABELS: Record<RuleType, string> = {
  assignable: '割り当て可能',
  prohibited: '割り当て禁止'
};

/**
 * ルールタイプが「割り当て可能」かどうか判定
 * @param ruleType RuleType ルールタイプ
 * @returns boolean 割り当て可能な場合true
 */
export function isAssignable(ruleType: RuleType): boolean {
  return ruleType === 'assignable';
}

/**
 * ルールタイプが「割り当て禁止」かどうか判定
 * @param ruleType RuleType ルールタイプ
 * @returns boolean 割り当て禁止の場合true
 */
export function isProhibited(ruleType: RuleType): boolean {
  return ruleType === 'prohibited';
}
